// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TransferModalOptions_EntityFragment = { __typename: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type TransferModalOptions_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, name: string, kind?: Types.ClientOrganizationKind | null };

export type TransferModalOptions_HouseholdFragment = { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }>, clientOrganizations?: Array<(
    { __typename?: 'ClientOrganization' }
    & TransferModalOptions_ClientOrganizationFragment
  )> | null, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & TransferModalOptions_EntityFragment
      ) | null } | null> | null } };

export type TransferModalOptionsQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type TransferModalOptionsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household', id: string }
        & TransferModalOptions_HouseholdFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    TransferModalOptions: 'TransferModalOptions' as const
  },
  Fragment: {
    TransferModalOptions_Entity: 'TransferModalOptions_Entity' as const,
    TransferModalOptions_ClientOrganization: 'TransferModalOptions_ClientOrganization' as const,
    TransferModalOptions_Household: 'TransferModalOptions_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TransferModalOptions_ClientOrganizationFragmentDoc = gql`
    fragment TransferModalOptions_ClientOrganization on ClientOrganization {
  id
  name
  kind
}
    `;
export const TransferModalOptions_EntityFragmentDoc = gql`
    fragment TransferModalOptions_Entity on Entity {
  __typename
  id
  kind
  stage
  subtype {
    id
    displayName
  }
}
    `;
export const TransferModalOptions_HouseholdFragmentDoc = gql`
    fragment TransferModalOptions_Household on Household {
  id
  possiblePrimaryClients {
    id
    displayName
  }
  clientOrganizations {
    ...TransferModalOptions_ClientOrganization
  }
  entities {
    edges {
      node {
        ...TransferModalOptions_Entity
      }
    }
  }
}
    ${TransferModalOptions_ClientOrganizationFragmentDoc}
${TransferModalOptions_EntityFragmentDoc}`;
export const TransferModalOptionsDocument = gql`
    query TransferModalOptions($householdId: ID!) {
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        ...TransferModalOptions_Household
      }
    }
  }
}
    ${TransferModalOptions_HouseholdFragmentDoc}`;

/**
 * __useTransferModalOptionsQuery__
 *
 * To run a query within a React component, call `useTransferModalOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferModalOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferModalOptionsQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useTransferModalOptionsQuery(baseOptions: Apollo.QueryHookOptions<TransferModalOptionsQuery, TransferModalOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferModalOptionsQuery, TransferModalOptionsQueryVariables>(TransferModalOptionsDocument, withFetchPolicyContext(options));
      }
export function useTransferModalOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferModalOptionsQuery, TransferModalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferModalOptionsQuery, TransferModalOptionsQueryVariables>(TransferModalOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTransferModalOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransferModalOptionsQuery, TransferModalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferModalOptionsQuery, TransferModalOptionsQueryVariables>(TransferModalOptionsDocument, withFetchPolicyContext(options));
        }
export type TransferModalOptionsQueryHookResult = ReturnType<typeof useTransferModalOptionsQuery>;
export type TransferModalOptionsLazyQueryHookResult = ReturnType<typeof useTransferModalOptionsLazyQuery>;
export type TransferModalOptionsSuspenseQueryHookResult = ReturnType<typeof useTransferModalOptionsSuspenseQuery>;
export type TransferModalOptionsQueryResult = Apollo.QueryResult<TransferModalOptionsQuery, TransferModalOptionsQueryVariables>;